module.exports = __webpack_public_path__ + "static/img/bandcamp-logotype-light-512.a37708b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bandcamp-logotype-light-512.png
// module id = Eqla
// module chunks = 1